// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typePickemPicksSubmitBody = {
  poolId: string;
  roundId: string;
  picks: {
    eventId: string;
    teamId: string;
    confidenceRank?: number | null;
    acceptsPendingSpread: boolean;
  }[];
  removeEventIds: string[];
  tiebreakerGuess?: number | null;
};

export type typePickemPicksSubmitOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | {
    picksMade: number;
    picksStillNeeded: number;
    savedAt: string;
    tiebreakerGuess: number | null;
  };
};

export type typePickemPicksSubmitOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typePickemPicksSubmitOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typePickemPicksSubmitOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaPickemPicksSubmitBody = {
  type: "object",
  properties: {
    poolId: { type: "string", maxLength: 3000, minLength: 1 },
    roundId: { type: "string", maxLength: 3000, minLength: 1 },
    picks: {
      type: "array",
      items: {
        type: "object",
        properties: {
          eventId: { type: "string", maxLength: 3000, minLength: 1 },
          teamId: { type: "string", maxLength: 3000, minLength: 1 },
          confidenceRank: { oneOf: [{ type: "integer" }, { enum: [null] }] },
          acceptsPendingSpread: { type: "boolean" },
        },
        required: ["eventId", "teamId", "acceptsPendingSpread"],
      },
    },
    removeEventIds: {
      type: "array",
      items: { type: "string", maxLength: 3000, minLength: 1 },
    },
    tiebreakerGuess: { oneOf: [{ type: "integer" }, { enum: [null] }] },
  },
  required: ["poolId", "roundId", "picks", "removeEventIds"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createPickemPicksSubmit(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaPickemPicksSubmitBody);
  }

  return async function postPickemPicksSubmit(
    payload: typePickemPicksSubmitBody,
  ): Promise<typePickemPicksSubmitOutput200 | typePickemPicksSubmitOutput400> {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postPickemPicksSubmit" failed before calling the network. #883dadec8a99`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#883dadec8a99" },
        },
        data: null,
      } as typePickemPicksSubmitOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/pickem/picks-submit`,
      httpMethod: "POST",
      options,
    })) as typePickemPicksSubmitOutput200 | typePickemPicksSubmitOutput400;
  };
}
